import cookieStorage from '../features/cookie'

export const useCurrentMerchantCountryCode = () => {
	const currentMerchantCountryCode = cookieStorage.getItem('currentMerchantCountryCode')

	return { currentMerchantCountryCode }
}
